var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/split-config.ts
function defineSplitPage(config) {
  return config;
}
__name(defineSplitPage, "defineSplitPage");

// src/use-split-page.ts
import { useQuery } from "@tanstack/react-query";
import { useListPage } from "@repo/list";

// src/use-drawer-param.ts
import React from "react";
function useDrawerParam(urlAdapter, paramKey = "drawer") {
  const [stateId, setStateId] = React.useState(null);
  if (urlAdapter) {
    return {
      id: urlAdapter.readParams()[paramKey] ?? null,
      open: /* @__PURE__ */ __name((value) => {
        const current = urlAdapter.readParams();
        urlAdapter.writeParams({
          ...current,
          [paramKey]: value
        });
      }, "open"),
      close: /* @__PURE__ */ __name(() => {
        const current = urlAdapter.readParams();
        const p = {
          ...current
        };
        delete p[paramKey];
        urlAdapter.writeParams(p);
      }, "close")
    };
  }
  return {
    id: stateId,
    open: setStateId,
    close: /* @__PURE__ */ __name(() => setStateId(null), "close")
  };
}
__name(useDrawerParam, "useDrawerParam");

// src/use-split-page.ts
function useSplitPage(config, listFetchFn, urlAdapter) {
  const list = useListPage(config.listConfig, listFetchFn, urlAdapter);
  const drawer = useDrawerParam(urlAdapter, config.drawerParamKey ?? "drawer");
  const detailQuery = useQuery({
    queryKey: [
      config.resource,
      "detail",
      drawer.id
    ],
    queryFn: /* @__PURE__ */ __name(() => config.detailFetchById(drawer.id), "queryFn"),
    enabled: drawer.id !== null
  });
  return {
    data: list.data,
    meta: list.meta,
    isLoading: list.isLoading,
    isError: list.isError,
    error: list.error,
    refetch: list.refetch,
    page: list.page,
    setPage: list.setPage,
    search: list.search,
    setSearch: list.setSearch,
    sort: list.sort,
    setSort: list.setSort,
    filters: list.filters,
    setFilter: list.setFilter,
    resetFilters: list.resetFilters,
    resetAll: list.resetAll,
    selectedId: drawer.id,
    openDrawer: drawer.open,
    closeDrawer: drawer.close,
    detailData: detailQuery.data,
    isDetailLoading: detailQuery.isLoading,
    isDetailError: detailQuery.isError
  };
}
__name(useSplitPage, "useSplitPage");
export {
  defineSplitPage,
  useDrawerParam,
  useSplitPage
};
//# sourceMappingURL=index.js.map